const selectors = {
  tablist: '[role="tablist"]',
  tab: '[role="tab"]',
};

export default function (initialIndex = 0) {
  return {
    selectedIndex: null,

    init() {
      // Set the first available tab on the page on page load.
      this.$nextTick(() => this.select(initialIndex));
    },

    // Selectors

    get tablist() {
      return this.$el.querySelector(selectors.tablist);
    },

    get tabs() {
      return this.tablist?.querySelectorAll(selectors.tab);
    },

    getTab(index) {
      return this.tabs?.[index];
    },

    isSelected(index) {
      return this.selectedIndex === index;
    },

    // Actions

    select(index, scrollIntoView = true) {
      this.selectedIndex = index;

      const tab = this.getTab(index);
      if (tab && scrollIntoView) {
        this.tablist.scrollTo({
          top: 0,
          left: tab.offsetLeft - tab.clientWidth,
          behavior: 'smooth',
        });
      }
    },

    // Shared directives

    bindTabs: {
      ['x-id']: "['tab', 'tab-panel']",
    },

    bindTablist: {
      [':role']: "'tablist'",
      ['@keydown.right.prevent.stop']: '$focus.wrap().next()',
      ['@keydown.home.prevent.stop']: '$focus.first()',
      ['@keydown.page-up.prevent.stop']: '$focus.first()',
      ['@keydown.left.prevent.stop']: '$focus.wrap().prev()',
      ['@keydown.end.prevent.stop']: '$focus.last()',
      ['@keydown.page-down.prevent.stop']: '$focus.last()',
    },

    bindTabpanels: {},

    bindTab(index) {
      return {
        [':id']: `$id('tab', ${index + 1})`,
        [':role']: "'tab'",
        ['@click']: `select(${index})`,
        ['@mousedown.prevent']: '',
        ['@focus']: `select(${index})`,
        [':tabindex']: `isSelected(${index}) ? 0 : -1`,
        [':aria-selected']: `isSelected(${index})`,
        [':aria-controls']: `$id('tab-panel', ${index + 1})`,
      };
    },

    bindTabpanel(index) {
      return {
        [':id']: `$id('tab-panel', ${index + 1})`,
        [':role']: "'tabpanel'",
        ['x-show']: `isSelected(${index})`,
        [':aria-labelledby']: `$id('tab', ${index + 1})`,
      };
    },
  };
}
